// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryMenu-module__container___2zhzh","collections":"CategoryMenu-module__collections___jZrOm"};